import { charlotteMediaArray } from './charlotteMedia'
import { charlotteBio } from './charlotteBios'
import { carrieProfileReviewHinge, mirandaProfileReviewBumble, samanthaProfileReviewTinder } from './charlotteProfileReviews'

export const charlotteDatingProfileHinge = {
  _id: 'charlotteDatingProfileHingeId',
  userId: 'charlotteUserId',
  email: 'charlotte@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: charlotteMediaArray[0]._id,
      mediaItemURL: charlotteMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[0].type,
      caption: charlotteMediaArray[0].captions[1],
      subcaption: charlotteMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[4]._id,
      mediaItemURL: charlotteMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[4].type,
      caption: charlotteMediaArray[4].captions[1],
      subcaption: charlotteMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[7]._id,
      mediaItemURL: charlotteMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[7].type,
      caption: charlotteMediaArray[7].captions[1],
      subcaption: charlotteMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[9]._id,
      mediaItemURL: charlotteMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[9].type,
      caption: charlotteMediaArray[9].captions[1],
      subcaption: charlotteMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[6]._id,
      mediaItemURL: charlotteMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[6].type,
      caption: charlotteMediaArray[6].captions[2],
      subcaption: charlotteMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[5]._id,
      mediaItemURL: charlotteMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[5].type,
      caption: charlotteMediaArray[5].captions[0],
      subcaption: charlotteMediaArray[5].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: charlotteBio._id,
    vitalInfo: { ...charlotteBio.vitalInfo },
    prompts: [
      { ...charlotteBio.prompts[0] },
      { ...charlotteBio.prompts[1] },
      { ...charlotteBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...carrieProfileReviewHinge }
  ],
  mediaItems: [ ...charlotteMediaArray ],
  bioItems: { ...charlotteBio },
}

export const charlotteDatingProfileBumble = {
  _id: 'charlotteDatingProfileBumbleId',
  userId: 'charlotteUserId',
  email: 'charlotte@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: charlotteMediaArray[0]._id,
      mediaItemURL: charlotteMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[0].type,
      caption: charlotteMediaArray[0].captions[1],
      subcaption: charlotteMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[4]._id,
      mediaItemURL: charlotteMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[4].type,
      caption: charlotteMediaArray[4].captions[1],
      subcaption: charlotteMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[7]._id,
      mediaItemURL: charlotteMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[7].type,
      caption: charlotteMediaArray[7].captions[1],
      subcaption: charlotteMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[9]._id,
      mediaItemURL: charlotteMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[9].type,
      caption: charlotteMediaArray[9].captions[1],
      subcaption: charlotteMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[6]._id,
      mediaItemURL: charlotteMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[6].type,
      caption: charlotteMediaArray[6].captions[2],
      subcaption: charlotteMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[5]._id,
      mediaItemURL: charlotteMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[5].type,
      caption: charlotteMediaArray[5].captions[0],
      subcaption: charlotteMediaArray[5].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: charlotteBio._id,
    vitalInfo: { ...charlotteBio.vitalInfo },
    prompts: [
      { ...charlotteBio.prompts[0] },
      { ...charlotteBio.prompts[1] },
      { ...charlotteBio.prompts[2] }
    ],
    aboutMe: charlotteBio.aboutMe[0],
    hobbies: [charlotteBio.hobbies[0], charlotteBio.hobbies[1], charlotteBio.hobbies[2], charlotteBio.hobbies[3], charlotteBio.hobbies[4] ],
  },
  profileReviews: [
    { ...mirandaProfileReviewBumble }
  ],
  mediaItems: [ ...charlotteMediaArray ],
  bioItems: { ...charlotteBio },
}

export const charlotteDatingProfileTinder = {
  _id: 'charlotteDatingProfileTinderId',
  userId: 'charlotteUserId',
  email: 'charlotte@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: charlotteMediaArray[0]._id,
      mediaItemURL: charlotteMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[0].type,
      caption: charlotteMediaArray[0].captions[1],
      subcaption: charlotteMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[4]._id,
      mediaItemURL: charlotteMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[4].type,
      caption: charlotteMediaArray[4].captions[1],
      subcaption: charlotteMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[7]._id,
      mediaItemURL: charlotteMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[7].type,
      caption: charlotteMediaArray[7].captions[1],
      subcaption: charlotteMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[9]._id,
      mediaItemURL: charlotteMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[9].type,
      caption: charlotteMediaArray[9].captions[1],
      subcaption: charlotteMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[6]._id,
      mediaItemURL: charlotteMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[6].type,
      caption: charlotteMediaArray[6].captions[2],
      subcaption: charlotteMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[5]._id,
      mediaItemURL: charlotteMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[5].type,
      caption: charlotteMediaArray[5].captions[0],
      subcaption: charlotteMediaArray[5].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: charlotteBio._id,
    vitalInfo: { ...charlotteBio.vitalInfo },
    prompts: [
      { ...charlotteBio.prompts[0] },
      { ...charlotteBio.prompts[1] },
      { ...charlotteBio.prompts[2] }
    ],
    aboutMe: charlotteBio.aboutMe[0],
    hobbies: [charlotteBio.hobbies[0], charlotteBio.hobbies[1], charlotteBio.hobbies[2], charlotteBio.hobbies[3], charlotteBio.hobbies[4] ],
  },
  profileReviews: [
    { ...samanthaProfileReviewTinder }
  ],
  mediaItems: [ ...charlotteMediaArray ],
  bioItems: { ...charlotteBio },
}